import { Stack, styled } from '@mui/material'
import { memo } from 'react'
import { useDispatch } from 'react-redux'
import { useShowListType } from 'store/orderbook/hooks'
import { ShowListType } from 'store/orderbook/types'

import { updateShowListType } from 'store/orderbook/actions'
import { ReactComponent as SvgIconDefaultActive } from './assets/default-active.svg'
import { ReactComponent as SvgIconDefault } from './assets/default.svg'
import { ReactComponent as SvgIconFallActive } from './assets/fall-active.svg'
import { ReactComponent as SvgIconFall } from './assets/fall.svg'
import { ReactComponent as SvgIconRiseActive } from './assets/rise-active.svg'
import { ReactComponent as SvgIconRise } from './assets/rise.svg'

export const SvgIconWrap = styled('div')`
  width: 16px;
  height: 16px;
  margin-right: 18px;
  cursor: pointer;
  &:hover,
  &.active {
    svg {
      display: none;
      &.icon-active {
        display: flex;
      }
      cursor: pointer;
    }
  }
  svg {
    &.icon-active {
      display: none;
    }
    cursor: pointer;
  }
`

export const OrderbookListType = memo(() => {
  const dispatch = useDispatch()
  const showListType = useShowListType()

  return (
    <Stack direction="row">
      <SvgIconWrap
        className={showListType === ShowListType.all ? 'active' : ''}
      >
        <SvgIconDefault
          onClick={() => dispatch(updateShowListType(ShowListType.all))}
        />
        <SvgIconDefaultActive
          className="icon-active"
          onClick={() => dispatch(updateShowListType(ShowListType.all))}
        />
      </SvgIconWrap>
      <SvgIconWrap
        className={showListType === ShowListType.sell ? 'active' : ''}
      >
        <SvgIconFall
          onClick={() => dispatch(updateShowListType(ShowListType.sell))}
        />
        <SvgIconFallActive
          className="icon-active"
          onClick={() => dispatch(updateShowListType(ShowListType.sell))}
        />
      </SvgIconWrap>
      <SvgIconWrap
        className={showListType === ShowListType.buy ? 'active' : ''}
      >
        <SvgIconRise
          onClick={() => dispatch(updateShowListType(ShowListType.buy))}
        />
        <SvgIconRiseActive
          className="icon-active"
          onClick={() => dispatch(updateShowListType(ShowListType.buy))}
        />
      </SvgIconWrap>
    </Stack>
  )
})
